module.exports = __webpack_public_path__ + "static/media/chloe.98d05fdc.jpg";